import React from "react";
import { useState, useEffect } from "react";
import { Form, Button, Col, Row, Container, Modal } from "react-bootstrap";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import "./IngredientesModal.css";
import { addDoc, collection, deleteDoc, doc, setDoc } from "firebase/firestore";
import { projectFirestore } from "../../../../firebase/config";
const IngredientesModal = ({
  menu,
  showReceta,
  mod,
  categorias,
  itemAnadido,
  handleCloseAñadido,
}) => {
  const [initialAnadidoState, setAnadidoState] = useState({
    id: "",
    name: "",
    cantidad: "",
    categorias: [],
  });
  const { register } = useAuthContext();

  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      if (e.target.name === "free") {
        setAnadidoState({
          ...initialAnadidoState,
          [e.target.name]: e.target.checked,
        });
      } else {
        const categorias = [...initialAnadidoState.categorias];
        if (categorias.includes(e.target.name)) {
          categorias.splice(categorias.indexOf(e.target.name), 1);
        } else {
          categorias.push(e.target.name);
        }
        setAnadidoState({
          ...initialAnadidoState,
          categorias: categorias,
        });
      }
    } else {
      setAnadidoState({
        ...initialAnadidoState,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleCloseLocal = async () => {
    setAnadidoState({
      id: "",
      name: "",
      cantidad: "",
      categorias: [],
    });
    handleCloseAñadido();
  };

  const saveReceta = async () => {
    if (mod === "ADD") {
      const btn = document.getElementById("BtnGuardar");
      btn.disabled = true;
      if (initialAnadidoState.categorias.length === 0) {
        alert("El añadido requiere categorías");
        btn.disabled = false;
        return;
      }
      if (initialAnadidoState.name === "") {
        alert("El añadido requiere un nombre");
        btn.disabled = false;
        return;
      }
      if (
        initialAnadidoState.cantidad === "" ||
        parseFloat(initialAnadidoState.cantidad) <= 0
      ) {
        alert("El añadido requiere una cantidad limite");
        btn.disabled = false;
        return;
      }
      await addDoc(
        collection(projectFirestore, "menu", menu.id, "ingredientes"),
        initialAnadidoState
      );
      handleCloseLocal();
    } else if (mod === "UPD") {
      const btn = document.getElementById("BtnGuardar");
      btn.disabled = true;
      if (initialAnadidoState.categorias.length === 0) {
        alert("El añadido requiere categorías");
        btn.disabled = false;
        return;
      }
      if (initialAnadidoState.name === "") {
        alert("El añadido requiere un nombre");
        btn.disabled = false;
        return;
      }
      if (
        initialAnadidoState.cantidad === "" ||
        parseFloat(initialAnadidoState.cantidad) <= 0
      ) {
        alert("El añadido requiere una cantidad limite");
        btn.disabled = false;
        return;
      }
      setDoc(
        doc(
          projectFirestore,
          "menu",
          menu.id,
          "ingredientes",
          initialAnadidoState.id
        ),
        initialAnadidoState
      );
      handleCloseLocal();
    } else if (mod === "DLT") {
      const btn = document.getElementById("BtnGuardar");
      btn.disabled = true;
      await deleteDoc(
        doc(
          projectFirestore,
          "menu",
          menu.id,
          "ingredientes",
          initialAnadidoState.id
        )
      );

      handleCloseLocal();
    }
  };

  useEffect(() => {
    if (showReceta) {
      if (mod === "UPD" || mod === "DLT") {
        setAnadidoState(itemAnadido);
      } else {
        setAnadidoState({
          id: "",
          name: "",
          cantidad: "",
          categorias: [],
        });
      }
    }
  }, [showReceta, mod, menu, register.id, itemAnadido]);

  return (
    <Modal show={showReceta} onHide={handleCloseLocal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title> Ingrediente </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <Form>
                <div id="Ingredientes">
                  <Row>
                    <Col
                      md={3}
                      style={{ textAlign: "right", paddingTop: "8px" }}
                    >
                      Nombre:
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formName">
                        <Form.Control
                          type="text"
                          name="name"
                          disabled={mod === "DLT" ? mod : ""}
                          value={initialAnadidoState.name}
                          placeholder="Ingresa un nombre"
                          onChange={(e) => handleChange(e)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}></Col>
                  </Row>
                  <br />
                  <Row>
                    <Col
                      md={3}
                      style={{ textAlign: "right", paddingTop: "15px" }}
                    >
                      Cantidad:
                    </Col>
                    <Col md={6} style={{ paddingTop: "5px" }}>
                      <Form.Group controlId="formName">
                        <Form.Control
                          type="number"
                          name="cantidad"
                          placeholder="0"
                          value={initialAnadidoState.cantidad}
                          onChange={(e) => handleChange(e)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col
                      md={3}
                      style={{ textAlign: "right", paddingTop: "8px" }}
                    >
                      Categorias vinculadas:
                    </Col>
                    <Col md={6}>
                      <div
                        className="scrollcat"
                        disabled={mod === "DLT" ? mod : ""}
                      >
                        {categorias.map((val, index) => (
                          <Row>
                            <input
                              style={{
                                marginTop: "10px !important",
                                marginBottom: "0px !important",
                                marginLeft: "0px !important",
                              }}
                              className="form-check-input"
                              type="checkbox"
                              disabled={mod === "DLT" ? mod : ""}
                              name={val.name}
                              checked={
                                initialAnadidoState.categorias.includes(
                                  val.name
                                )
                                  ? true
                                  : false
                              }
                              onChange={(e) => handleChange(e)}
                              id="flexSwitchCheck"
                            />
                            <label
                              className="lblqrdinamico"
                              style={{
                                paddingTop: "10px",
                                paddingLeft: "20px",
                                width: "10px",
                              }}
                            >
                              {val.name}
                            </label>
                          </Row>
                        ))}
                      </div>
                    </Col>
                    <Col md={3}></Col>
                  </Row>
                </div>
                <br />
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseLocal}>
          CANCELAR
        </Button>
        <Button
          id="BtnGuardar"
          variant={mod && mod === "DLT" ? "danger" : "primary"}
          onClick={saveReceta}
        >
          {mod && mod === "DLT" ? "ELIMINAR" : "GUARDAR"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default IngredientesModal;
